var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M42.6667 0H5.33333C2.4 0 0 2.4 0 5.33333V42.6667C0 45.6 2.4 48 5.33333 48H42.6667C45.6 48 48 45.6 48 42.6667V5.33333C48 2.4 45.6 0 42.6667 0ZM13.3333 37.3333C11.8667 37.3333 10.6667 36.1333 10.6667 34.6667V21.3333C10.6667 19.8667 11.8667 18.6667 13.3333 18.6667C14.8 18.6667 16 19.8667 16 21.3333V34.6667C16 36.1333 14.8 37.3333 13.3333 37.3333ZM24 37.3333C22.5333 37.3333 21.3333 36.1333 21.3333 34.6667V13.3333C21.3333 11.8667 22.5333 10.6667 24 10.6667C25.4667 10.6667 26.6667 11.8667 26.6667 13.3333V34.6667C26.6667 36.1333 25.4667 37.3333 24 37.3333ZM34.6667 37.3333C33.2 37.3333 32 36.1333 32 34.6667V29.3333C32 27.8667 33.2 26.6667 34.6667 26.6667C36.1333 26.6667 37.3333 27.8667 37.3333 29.3333V34.6667C37.3333 36.1333 36.1333 37.3333 34.6667 37.3333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/surveyIcon.ca8b2207.svg";
export { ForwardRef as ReactComponent };